import { render, staticRenderFns } from "./AltaUbicacion.vue?vue&type=template&id=6847bfd1"
import script from "./AltaUbicacion.vue?vue&type=script&lang=js"
export * from "./AltaUbicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports